export default "__VITE_PUBLIC_ASSET__8c808b37__"